module.exports = __webpack_public_path__ + "8de63a00e050cfc28087dcd181d28f8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/1.svg
// module id = 696
// module chunks = 0